import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  OrderCheckout,
  OrderLines,
} from '@features/user/interfaces/order.interface';
import { OrderService } from '@features/user/services/order.service';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'fc-user-invoice',
  templateUrl: './user-invoice.component.html',
  styleUrls: ['./user-invoice.component.css'],
})
export class UserInvoiceComponent implements OnInit {
  faChevronLeft = faChevronLeft;

  checkoutId: number;
  checkout: OrderCheckout = {} as OrderCheckout;
  lines: OrderLines[] = [] as OrderLines[];

  constructor(
    private orderService: OrderService,
    private route: ActivatedRoute,
    private router: Router,
    private loaction: Location,
    private layoutService: LayoutService
  ) {
    this.checkoutId = Number(this.route.snapshot.paramMap.get('checkoutId'));
    if (this.layoutService.isMobile$) {
      this.layoutService.setFooterVisibility(false);
      this.layoutService.setMobileLayoutConfig({
        headerNav: {
          backButton: true,
          title: 'Invoice Checkout',
          searchButton: false,
          cartButton: false,
          notificationButton: false,
          userButton: true,
        },
        bottomNav: {
          visibillity: false,
        },
      });
    }
  }

  ngOnDestroy(): void {
    if (this.layoutService.isMobile$) {
      this.layoutService.setFooterVisibility(true);
      this.layoutService.setDefaultMobileLayoutConfig();
    }
  }

  ngOnInit(): void {
    this.orderService.getOrderCheckout(this.checkoutId).subscribe((data) => {
      this.checkout = data.checkout;
      this.checkout.orders.forEach((order) => {
        order.lines.forEach((line) => this.lines.push(line));
      });
    });
  }

  makePayment() {
    this.router.navigate(['/checkout/manual-transfer/', this.checkoutId]);
    // note: need dynamic payment method
    // const paymentMethod = Number(this.checkout.payment_method);
    // if (paymentMethod == 1) {
    //   this.router.navigate([
    //     './payment/credit-card',
    //     {
    //       checkoutId: this.checkout.id,
    //       // tXid: checkout.tXid,
    //       // happyPayTopUpId: resData.happy_pay_top_up_id,
    //     },
    //   ]);
    // } else if (paymentMethod > 1 && paymentMethod <= 9) {
    //   this.router.navigate([
    //     './payment/virtual-account',
    //     {
    //       checkoutId: this.checkout.id,
    //       paymentMethod: paymentMethod,
    //       // vaccNo: resData.vacc_no,
    //       // happyPayTopUpId: resData.happy_pay_top_up_id
    //     },
    //   ]);
    // }
  }

  back() {
    this.loaction.back();
  }
}
